import {
  listCustomPagesOptions,
  retrieveCustomPageOptions,
} from '@common/admin/custom-pages/custom-pages-queries';
import {
  systemPageOptions,
  systemPagesOptions,
} from '@common/admin/custom-pages/system-pages/system-pages-queries';
import {authGuard} from '@common/auth/guards/auth-route';
import {queryClient} from '@common/http/query-client';
import {RouteObject} from 'react-router';

export const adminCustomPagesRoutes: Record<string, RouteObject> = {
  index: {
    path: 'custom-pages',
    lazy: () => import('@common/admin/custom-pages/custom-page-datable'),
    shouldRevalidate: () => false,
    loader: async () => {
      const redirect = authGuard({permission: 'custom_pages.update'});
      if (redirect) return redirect;
      await Promise.all([
        queryClient.ensureQueryData(listCustomPagesOptions()),
        queryClient.ensureQueryData(systemPagesOptions()).catch(() => null),
      ]);
    },
  },
  create: {
    path: 'custom-pages/new',
    loader: () => authGuard({permission: 'custom_pages.update'}),
    lazy: () => import('@common/admin/custom-pages/create-custom-page'),
  },
  update: {
    path: 'custom-pages/:pageId/edit',
    lazy: () => import('@common/admin/custom-pages/edit-custom-page'),
    loader: async ({params}) => {
      const redirect = authGuard({permission: 'custom_pages.update'});
      if (redirect) return redirect;
      await queryClient.ensureQueryData(
        retrieveCustomPageOptions(params.pageId!),
      );
    },
  },
  system: {
    path: 'custom-pages/system/:pageKey',
    lazy: () =>
      import('@common/admin/custom-pages/system-pages/system-page-editor'),
    loader: async ({params}) => {
      const redirect = authGuard({permission: 'custom_pages.update'});
      if (redirect) return redirect;
      await queryClient.ensureQueryData(systemPageOptions(params.pageKey!));
    },
  },
};
